import cx from 'classnames'
import { FormApi } from 'final-form'
import React from 'react'
import { Field, Form } from 'react-final-form'
import { FormProps } from 'react-final-form'

import { Go, Search } from '@cinch/oxd-components/icons/src'
import LoadingSpinner from '@cinch/oxd-components/loading-spinner/src'
import SVG from '@cinch/oxd-components/svg/src'

import * as styles from './search.module.css'

const BTN_SIZE_INPUTS = 26

interface CustomStyles {
  search?: string
  wrapper?: string
  container?: string
  input?: string
  searchIcon?: string
  goButton?: string
}

export interface SearchProps extends Pick<FormProps, 'onSubmit'> {
  initialSearchValue?: string
  searchPending?: boolean
  customStyles?: CustomStyles
  i18n: Cinch.WebAppTranslations['findVehicle']['search']
  gradientId?: string
  autocomplete?: string
}

const SearchComponent: React.FC<SearchProps> = ({
  searchPending,
  initialSearchValue = '',
  onSubmit,
  customStyles = {},
  i18n,
  gradientId,
  autocomplete,
}) => {
  const inputRef = React.createRef<HTMLInputElement>()

  const onClickSubmit = (values: { [key: string]: any }, form: FormApi, callback?: (errors?: object) => void) => {
    onSubmit(values, form, callback)

    if (inputRef.current) {
      form.blur('search') // mark final form's internal state for the "search" field as blurred.
      inputRef.current.blur()
    }
  }

  return (
    <div className={cx(styles.search, customStyles.search)}>
      <Form
        onSubmit={onClickSubmit}
        initialValues={{ search: initialSearchValue }}
        render={({ handleSubmit, invalid }) => (
          <form className={cx(styles.wrapper, customStyles.wrapper)} onSubmit={handleSubmit}>
            <div className={cx(styles.container, customStyles.container)}>
              <SVG
                children={Search}
                size={BTN_SIZE_INPUTS}
                hasGradient={true}
                gradientId={gradientId}
                className={cx(styles.searchIcon, customStyles.searchIcon)}
              />
              <Field
                name="search"
                render={({ input }) => (
                  <input
                    {...input}
                    ref={inputRef}
                    type="search"
                    aria-label={i18n.placeholder}
                    placeholder={i18n.placeholder}
                    autoComplete={autocomplete}
                    className={cx(styles.input, customStyles.input)}
                  />
                )}
              />
              <button
                className={cx(styles.goButton, customStyles.goButton)}
                title={i18n.search}
                type="submit"
                disabled={invalid || searchPending}
              >
                {searchPending ? (
                  <LoadingSpinner size={BTN_SIZE_INPUTS} />
                ) : (
                  <SVG children={Go} size={BTN_SIZE_INPUTS} hasGradient={true} gradientId={gradientId} />
                )}
              </button>
            </div>
          </form>
        )}
      />
    </div>
  )
}

export default SearchComponent
